import React from 'react';
import { MOTIVOS } from '../utils/sesiones';

interface Props {
  motivo: string;
  nota: string;
  onMotivo: (v: string) => void;
  onNota: (v: string) => void;
  disabled?: boolean;
}

const CLASE_CAMPO =
  'mt-1 w-full rounded-md border border-solid border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-blue-500 focus:outline-none';

/** Motivo (lista de la maqueta) y nota libre: quedan en la bitácora de la cuenta. */
export const MotivoCampos: React.FC<Props> = ({ motivo, nota, onMotivo, onNota, disabled }) => (
  <div className="space-y-3">
    <label className="block text-sm font-medium text-gray-700">
      Motivo
      <select className={CLASE_CAMPO} value={motivo} onChange={(e) => onMotivo(e.target.value)} disabled={disabled}>
        {MOTIVOS.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </label>
    <label className="block text-sm font-medium text-gray-700">
      Nota (opcional)
      <textarea
        className={CLASE_CAMPO}
        rows={2}
        maxLength={180}
        value={nota}
        onChange={(e) => onNota(e.target.value)}
        disabled={disabled}
      />
    </label>
  </div>
);
